var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentManagementIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_792_5934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.5H0.5V24.5H24.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_792_5934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.25C21.5 9.85218 21.5 8.90326 21.2716 8.35195C20.9672 7.61687 20.3831 7.03284 19.6481 6.72836C19.0967 6.5 18.3978 6.5 17 6.5C15.9714 6.5 14.9428 6.5 13.9142 6.5C13.7456 6.5 13.6613 6.5 13.5801 6.49559C12.8976 6.45855 12.2482 6.18957 11.7394 5.73317C11.6788 5.67884 11.6192 5.61923 11.5 5.5C11.3808 5.38077 11.3212 5.32116 11.2606 5.26683C10.7518 4.81043 10.1024 4.54145 9.41994 4.50441C9.33871 4.5 9.2544 4.5 9.08579 4.5C8.82386 4.5 8.56193 4.5 8.3 4.5C6.61984 4.5 5.77976 4.5 5.13803 4.82698C4.57354 5.1146 4.1146 5.57354 3.82698 6.13803C3.5 6.77976 3.5 7.61984 3.5 9.3C3.5 11.4333 3.5 13.5667 3.5 15.7C3.5 17.3802 3.5 18.2202 3.82698 18.862C4.1146 19.4265 4.57354 19.8854 5.13803 20.173C5.77976 20.5 6.61984 20.5 8.3 20.5C9.7 20.5 11.1 20.5 12.5 20.5",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.5C3.5 11.5 3.5 14.3 3.5 15.7C3.5 17.3802 3.5 18.2202 3.82698 18.862C4.1146 19.4265 4.57354 19.8854 5.13803 20.173C5.77976 20.5 6.61984 20.5 8.3 20.5C11.1 20.5 13.9 20.5 16.7 20.5C18.3802 20.5 19.2202 20.5 19.862 20.173C20.4265 19.8854 20.8854 19.4265 21.173 18.862C21.342 18.5302 21.4237 16.9483 21.4631 15.3039C21.5 13.7673 21.5 12.1763 21.5 11.5H3.5Z",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentManagementIcon);
export default __webpack_public_path__ + "static/media/DocumentManagementIcon.20d309876f41c537bd1b3276497a2fd3.svg";
export { ForwardRef as ReactComponent };